import { DefaultType, DefaultProps, AdSeriesProps } from './datatype';
export const dataHandle = (data:DefaultType) => {
    const keys = Object.keys(data);
    if (keys.length < 0) return;
    const filterData = keys.reduce((prev: DefaultProps[], next: string)=> {
        prev.push({ id: next, val: data[next]});
        return prev;
    }, []);
    return filterData || [];
}

export const dataHandleForArray = (data: DefaultType[]) => {
    if (data.length === 0) return;
    const filterData = data.reduce((prev: DefaultProps[], next: DefaultType)=> {
        prev.push({ id: next.key, val: next.value});
        return prev;
    }, []);
    return filterData || null;
}

export const mergeAndReplaceArrays = (dataSource: AdSeriesProps[], dataTarget: AdSeriesProps[]) => {
    const map = new Map<number, AdSeriesProps>();
    const result: AdSeriesProps[] = [];
   
    dataSource.forEach(item => map.set(item.campaignId, item));   
    dataTarget.forEach(item => {
      if (map.has(item.campaignId)) {
        map.set(item.campaignId, item);
      } else {
        result.push(item);
      }
    });
    
    map.forEach((value, key) => {
      result.push(value);
    });
   
    return result;
  }

export const downloadCSV = (data: string, filename: string) => {
    const csvContent = "data:text/csv;charset=utf-8," + data;
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", filename);
    link.click();
}